<template>
    <div>
        <v-btn text color="error" @click="defeatInvestigator">
            Defeat
        </v-btn>
        <v-btn text color="error" @click="devourInvestigator">
            Devour
        </v-btn>

        <v-dialog v-model="dialog" persistent max-width="290">
            <template v-slot:activator="{ on }">
                <v-btn text color="primary" v-on="on" @click="dialog = !dialog">
                    Move
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="headline">Move {{ investigator.investigator.title }}</v-card-title>
                <v-card-text>
                    <v-select :items="investigatorSessions"
                              item-text="investigator.title"
                              item-value="id"
                              v-model="investigatorSessionId"
                              label="After investigator"
                              hide-details/>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="secondary" text @click="dialog = false">Cancel</v-btn>
                    <v-btn color="primary" text @click="moveAfter">Move</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  import InvestigatorSessionService from "../services/InvestigatorSessionService";

  export default {
    props: ["investigator", "investigatorSessions"],

    data: () => ({
      dialog: null,
      investigatorSessionId: null
    }),

    methods: {
      defeatInvestigator() {
        if (confirm(`Are you sure you want to have ${this.investigator.title} defeated?`)) {
          InvestigatorSessionService.defeat(this.investigator.id)
            .then(() => {
              this.$emit("investigatorUpdated");
            });
        }
      },

      devourInvestigator() {
        if (confirm(`Are you sure you want to have ${this.investigator.title} devoured?`)) {
          InvestigatorSessionService.delete(this.investigator.id)
            .then(() => {
              this.$emit("investigatorUpdated");
            });
        }
      },

      moveAfter() {
        if (confirm(`Are you sure you want to move ${this.investigator.investigator.title}?`)) {
          InvestigatorSessionService.moveAfter(this.investigator.id, this.investigatorSessionId)
            .then(() => {
              this.$emit("investigatorUpdated");
              this.investigatorSessionId = null;
              this.dialog = false;
            });
        }
      }
    }
  };
</script>
